import { Select, ToggleButton, ToggleButtonGroup, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ButtonSwitch } from "src/components/ButtonSwitch/ButtonSwitch";

export const ResponsiveContainer = styled("div")(({ theme }) => ({
    fontFamily: theme.fonts.default,
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column",
    },
}));

export const ColumnContainer = styled("div")(({ theme }) => ({
    fontFamily: theme.fonts.default,
    display: "flex",
    flexDirection: "column"
}));

export const RowContainer = styled("div")(({ theme }) => ({
    fontFamily: theme.fonts.default,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
}));

export const GenericIcon = styled('div')(({ theme }) => ({
    display: "inline-block",
}));

export const GenericTypography = styled(Typography)(({ theme }) => ({
    fontFamily: theme.fonts.default,
}));

export const ChangeStatusGroupToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    borderRadius: "6px",
    gap: "2px",
    "> button": {
        padding: "12px 20px"
    }
}));

export const ChangeStatusGroupToggleButton = styled(ToggleButton)(({ theme }) => ({
    fontFamily: theme.fonts.default,
    backgroundColor: theme.colors["neutral.800"],
    padding: "8px 12px",
    borderRadius: "6px",
    border: `2px solid ${theme.colors["neutral.800"]}`,
    "&.MuiToggleButtonGroup-grouped:not(:first-of-type)" : {
        borderLeft: `2px solid ${theme.colors["neutral.800"]}`,
        borderTop: `2px solid ${theme.colors["neutral.800"]}`
    },
    "&:hover, &.MuiToggleButtonGroup-grouped:not(:first-of-type):hover, &.MuiToggleButtonGroup-grouped:is(:first-of-type):hover" : {
        backgroundColor: theme.colors["neutral.800"],
        borderColor: theme.colors["lime.500"],
        borderLeftColor: theme.colors["lime.500"],
        borderTopColor: theme.colors["lime.500"],
    },
    "&.Mui-selected, &.Mui-selected.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
        backgroundColor: theme.colors["neutral.800"],
        borderColor: theme.colors["lime.500"],
        borderLeftColor: theme.colors["lime.500"],
        borderTopColor: theme.colors["lime.500"],
    },
    textTransform:"none"
}));

export const SimpleDropDown = styled(Select)(({ theme }) => ({
    fontFamily: theme.fonts.default,
    backgroundColor: theme.colors["neutral.900"],
    borderRadius: "8px",
    color: theme.colors["neutral.50"],
    "& .MuiSelect-icon": {
        color: theme.colors["neutral.50"],
    }
}));

export const SimpleDropDownAlt = styled(SimpleDropDown)(({ theme }) => ({
    backgroundColor: theme.colors["neutral.950"],
}));

export const SimpleDropDownMenuProps = (useAlt?: boolean) => {
    const theme = useTheme();
    const bg = useAlt ? 
        theme.colors["neutral.950"] :
        theme.colors["neutral.900"];
    return {
        sx: {
            "&& .MuiMenu-root": {
                backgroundColor: bg,
                color: theme.colors["neutral.50"],
            },
            "&& .MuiPaper-root": {
                backgroundColor: bg,
                color: theme.colors["neutral.50"],
            },
        },
    };
}

export const Toast = styled(ColumnContainer)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    padding: "12px 16px",
    width: "100%"
}));

export const ToastBadges = styled(ColumnContainer)(({ theme }) => ({
    padding: "12px 16px"
}));

export const ToastTicketShadedBackground = styled('div')(({ theme }) => ({
    backgroundColor:"rgba(0,0,0,0.5)",
    width: "max-content",
    fontSize: theme.fontSizes.sm,
    padding: "4px 8px",
    borderRadius: "8px",
    color: theme.colors["neutral.400"]
}));

export const ToastBadgeShadedBackground = styled('div')(({ theme }) => ({
    backgroundColor:"rgba(0,0,0,0.5)",
    width: "max-content",
    padding: "4px",
    borderRadius: "16px",
}));

export const ToastHighlightBackground = styled('div')(({ theme }) => ({
    backgroundColor: theme.colors["lime.500"],
    color: theme.colors["lime.950"],
    fontWeight: "600",
    width: "max-content",
    padding: "6px 12px",
    borderRadius: "16px",
}));

export const ButtonSwitcher = styled(ButtonSwitch)(({ theme }) => ({
    fontFamily: theme.fonts.default,    
}));